import { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { useChartContext } from '../ChartProvider'

function ChartGraphic ({
  id,
  type,
  left,
  right,
  top,
  bottom,
  bounding,
  z,
  zlevel,
  silent,
  invisible,
  cursor,
  draggable,
  progressive,
  shape,
  style,
  children,
  origin,
  rotation,
  scale,
  position,
  width,
  height,
  onclick,
  onmouseover,
  onmouseout,
  onmousemove,
  onmousedown,
  onmouseup,
  ondrag,
  ondragstart,
  ondragend,
  ondblclick
}) {
  const { setKeyConfig } = useChartContext()

  useLayoutEffect(() => {
    const graphic = {
      id,
      type,
      left,
      right,
      top,
      bottom,
      bounding,
      z,
      zlevel,
      silent,
      invisible,
      cursor,
      draggable,
      progressive,
      shape,
      style,
      children,
      origin,
      rotation,
      scale,
      position,
      width,
      height,
      onclick,
      onmouseover,
      onmouseout,
      onmousemove,
      onmousedown,
      onmouseup,
      ondrag,
      ondragstart,
      ondragend,
      ondblclick
    }

    // Remove undefined props
    Object.keys(graphic).forEach(k => {
      if (graphic[k] === undefined) delete graphic[k]
    })

    setKeyConfig('graphic', [graphic])
  }, [
    setKeyConfig,
    id,
    type,
    left,
    right,
    top,
    bottom,
    bounding,
    z,
    zlevel,
    silent,
    invisible,
    cursor,
    draggable,
    progressive,
    shape,
    style,
    children,
    origin,
    rotation,
    scale,
    position,
    width,
    height,
    onclick,
    onmouseover,
    onmouseout,
    onmousemove,
    onmousedown,
    onmouseup,
    ondrag,
    ondragstart,
    ondragend,
    ondblclick
  ])

  return null
}

ChartGraphic.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(['image', 'text', 'rect', 'circle', 'ring', 'sector', 'arc', 'polygon', 'polyline', 'line', 'bezierCurve', 'group']),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bounding: PropTypes.oneOf(['all', 'raw']),
  z: PropTypes.number,
  zlevel: PropTypes.number,
  silent: PropTypes.bool,
  invisible: PropTypes.bool,
  cursor: PropTypes.string,
  draggable: PropTypes.bool,
  progressive: PropTypes.bool,
  shape: PropTypes.object,
  style: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.object),
  origin: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  rotation: PropTypes.number,
  scale: PropTypes.arrayOf(PropTypes.number),
  position: PropTypes.arrayOf(PropTypes.number),
  width: PropTypes.number,
  height: PropTypes.number,
  onclick: PropTypes.func,
  onmouseover: PropTypes.func,
  onmouseout: PropTypes.func,
  onmousemove: PropTypes.func,
  onmousedown: PropTypes.func,
  onmouseup: PropTypes.func,
  ondrag: PropTypes.func,
  ondragstart: PropTypes.func,
  ondragend: PropTypes.func,
  ondblclick: PropTypes.func
}

export default ChartGraphic
